import {
  APILoadingStatus,
  useApiLoadingStatus,
} from "@vis.gl/react-google-maps";
import { useTranslation } from "react-i18next";

export const GoogleAPILoader = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const apiStatus = useApiLoadingStatus();

  if (apiStatus !== APILoadingStatus.LOADED) {
    return <div>{t("api_loader.loading")}</div>;
  }

  return children;
};
